import { LOGIN, LOGOUT } from './../actions/auth/types'

const hasToken =
    typeof window !== 'undefined' && Boolean(localStorage.getItem('token'));

const initialState = {
    isLogged: hasToken,
};

const auth = (state = initialState, action: any) => {
    switch (action.type) {
        case LOGIN:
            return {
                ...state,
                isLogged: action.payload,
            };
        case LOGOUT:
            return { isLogged: false };
        default:
            return state;
    }
};

export default auth;
